// extracted by mini-css-extract-plugin
export var numpadContainer = "_sm-1";
export var phoneButton = "_sm-0";